import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { SimulatorComponent } from './components/simulator/simulator.component';
import { FooterComponent } from './components/footer/footer.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HomeComponent } from './components/home/home.component';
import { Settings } from './classes/settings/settings';
import { LogBoxComponent } from './components/log-box/log-box.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SimulatorComponent,
    FooterComponent,
    HomeComponent,
    LogBoxComponent
  ],
  imports: [
    BrowserModule,
    NgbModule,
    AppRoutingModule
  ],
  providers: [Settings],
  bootstrap: [AppComponent]
})
export class AppModule { }
